import React, { useEffect } from 'react';
import {
    PlaceholderContainer,
    PlaceholderText,
    PlaceholderSubtext
} from './ApplicationDashboard.styles';
import { BaseDashboardProps } from './dashboardTypes';

interface AIAnsweringDashboardProps extends BaseDashboardProps { }

const AIAnsweringDashboard: React.FC<AIAnsweringDashboardProps> = ({
    onLoadingChange
}) => {
    useEffect(() => {
        onLoadingChange?.(false); // Placeholder has no loading
    }, [onLoadingChange]);

    return (
        <PlaceholderContainer>
            <PlaceholderText>Organization-level analytics aren't supported for AI Answering today.</PlaceholderText>
            <PlaceholderSubtext>
                Migrate to AI Ordering to access full analytics and everything Voicify has to offer. Your Voicify contact can help get you started.
            </PlaceholderSubtext>
        </PlaceholderContainer>
    );
};

export default AIAnsweringDashboard;
export { AIAnsweringDashboard };
export type { AIAnsweringDashboardProps };
